import { render, staticRenderFns } from "./CompetitorsList.vue?vue&type=template&id=8f058096&scoped=true"
import script from "./CompetitorsList.vue?vue&type=script&lang=js"
export * from "./CompetitorsList.vue?vue&type=script&lang=js"
import style0 from "./CompetitorsList.vue?vue&type=style&index=0&id=8f058096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f058096",
  null
  
)

export default component.exports